<template>
  <div class="scs-expanding-input">
    <div class="expanding-input-heading">
      <round-button-with-icon :icon="processing ? 'spinner' : icon" />
      <h5 v-if="!inputActive" @click="toggleInputActive">{{ initial }}</h5>
      <input
        v-if="inputActive"
        type="text"
        class="expanding-input-input"
        :placeholder="placeholder"
        v-model="value"
        @blur="submitInput"
        @keydown.enter="submitInput"
      />
    </div>
  </div>
</template>
<script>
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
export default {
  data() {
    return {
      inputActive: false,
      value: undefined,
    };
  },
  computed: {},
  methods: {
    toggleInputActive() {
      this.inputActive = !this.inputActive;
    },
    submitInput() {
      // todo : add valid check function like formatter function
      if (this.value.replaceAll(" ", "").length > 0) {
        this.$emit("scs-input", this.value);
      }
      this.toggleInputActive();
    },
  },
  created() {},
  components: {
    RoundButtonWithIcon,
  },
  props: ["icon", "placeholder", "initial", "processing"],
  emits: ["scs-input"],
};
</script>
<style scoped>
.expanding-input-heading {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.expanding-input-heading > h5 {
  cursor: pointer;
  margin: 0;
  margin-left: 5px;
}

.expanding-input-input {
  border-radius: 15px;
  padding: 5px 10px;
  margin-left: 5px;
  border: 1px solid var(--secondaryColor);
  outline: none;
}
</style>
